import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountAuthorization } from 'src/model/accountAuthorization';
import { CustomerAccount } from 'src/model/customerAccount.model';
import { AccountAuthorizationService } from 'src/services/accountAuthorization.service';
import { CustomerAccountService } from 'src/services/customer-account.service';

@Component({
    selector: 'app-account-authorization-list',
    templateUrl: './account-authorization-list.component.html',
    styleUrl: './account-authorization-list.component.scss',
    standalone: false
})
export class AccountAuthorizationListComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private customerAccountService = inject(CustomerAccountService);
  private accountAuthorizationService = inject(AccountAuthorizationService);

  @Input() isModal: boolean;

  @Input() pendingAuthorizations: AccountAuthorization[] = [];
  accountsList: CustomerAccount[] = [];

  async ngOnInit(): Promise<void> {

    if (this.pendingAuthorizations.length == 0) {
      this.pendingAuthorizations = await this.accountAuthorizationService.getAllAccountAuthorizations(undefined, undefined, true);
      const acctIds = this.pendingAuthorizations.map(auth => auth.CustomerAccountId);
      this.accountsList = await this.customerAccountService.getAccountsDetails(acctIds);

    }
  }

  getAccount(acctId: number) {
    return this.accountsList.find(acct => acct.Id == acctId)
  }

  reset() {
    this.activeModal.close();
  }

}
